<script lang="ts">
  import { wait } from "$app/utils"
  import Button from "$app/components/ButtonSpinner.svelte"
  import {
    ChevronRight,
    ChevronLeft,
    Hand,
    ArrowLeftFromLine
  } from "lucide-svelte"

  import { onboardingStore } from "../onboarding.svelte"

  interface Props {
    showPrev: boolean
    showNext: boolean
    showSkip: boolean
    nextStepFn: any
    css: string
    skipContCss: string
  }

  let props = $props()

  let {
    showPrev = true,
    showNext = true,
    showSkip = true,
    nextStepFn = onboardingStore.nextStep,
    css = "",
    skipContCss = ""
  }: Props = props

  async function callFn() {
    await wait(100)
    nextStepFn()
  }
</script>

<div class="flex items-center py-4 mt-6 {css || 'max-w-lg justify-between'}">
  {#if showPrev}
    <Button
      class="btn btn-rounded btn-big secondary flex items-center gap-1"
      processing={onboardingStore.saving}
      onclick={() => {
        onboardingStore.prevStep()
      }}
    >
      <ChevronLeft class="text-gray-500 size-6" />
      <span class="text-gray-500">PREVIOUS</span>
    </Button>
  {/if}
  {#if showNext}
    <Button
      onclick={callFn}
      disabled={!onboardingStore.completed}
      processing={onboardingStore.saving}
      class="btn btn-rounded success btn-big"
    >
      <span class="text-core"> CONTINUE </span>
      <ChevronRight class="text-core size-6" />
    </Button>
  {/if}
</div>

{#if showSkip}
  <div class="mt-6 flex justify-start gap-x-5">
    <div class={skipContCss || ""}>
      <Button
        onclick={onboardingStore.skipOnboarding}
        processing={onboardingStore.saving}
        class="text-gray-200 border rounded-sm border-white px-6 hover:bg-indigo-600 hover:border-gray-100 hover:font-bold flex items-center gap-2 h-14"
      >
        <ArrowLeftFromLine class="text-gray-200 size-6" />
        Skip Onboarding
      </Button>
    </div>
    <div>
      <a
        href="https://calendly.com/anjalwp/lead-with-purpose-discovery-new-sign-up"
        target="_blank"
        class="text-gray-200 border rounded-sm border-white px-6 hover:bg-indigo-600 hover:border-gray-100 hover:font-bold h-14 flex items-center gap-2"
      >
        <Hand class="text-gray-200 size-6" />
        I need help
      </a>
    </div>
  </div>
{/if}
